import {isCategoryColor, isCategoryIcon} from 'common/categoryAppearance';
import * as React from 'react';
import {
  automaticCategoryColor,
  categoryIconComponents,
  categoryInlineIconClasses,
} from 'src/categoryAppearance';
import type {FullCategoryFragment} from '@transactions/graphql';

type Props = {
  category: FullCategoryFragment;
};

/**
 * Inline category identity — the category's icon in its tint color, then the
 * name. Icon-less categories render the name alone: at this size an invented
 * letter glyph would just be noise.
 */
export const CategoryInlineDisplay = ({category}: Props) => {
  const Icon =
    category.icon != null && isCategoryIcon(category.icon)
      ? categoryIconComponents[category.icon]
      : null;
  const color =
    category.color != null && isCategoryColor(category.color)
      ? category.color
      : automaticCategoryColor(category.name);
  return (
    <span className="flex shrink-0 items-center gap-1">
      {Icon && (
        <Icon
          className={`size-3.5 shrink-0 ${categoryInlineIconClasses[color]}`}
        />
      )}
      <span>{category.name}</span>
    </span>
  );
};
